const palette = {
  accent: { border: 'rgba(0,229,255,0.3)', color: '#00e5ff', bg: 'rgba(0,229,255,0.05)' },
  red:    { border: 'rgba(255,77,109,0.3)', color: '#ff4d6d', bg: 'rgba(255,77,109,0.05)' },
  green:  { border: 'rgba(168,255,62,0.3)', color: '#a8ff3e', bg: 'rgba(168,255,62,0.05)' },
  '':     { border: '#1a3040',              color: '#5a8a9f', bg: 'rgba(255,255,255,0.04)' },
};

export default function Tag({ label, color = '' }) {
  const c = palette[color] || palette[''];
  return (
    <span style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.65rem', padding: '0.25rem 0.65rem', background: c.bg, border: `1px solid ${c.border}`, color: c.color, letterSpacing: '0.05em' }}>
      {label}
    </span>
  );
}

export { palette };
